import React,{ useState } from "react";
import ImgEncu from "./../../imagenes/imgEncu.png";
import ScreenResize from "../Contenido/ScreenResize/ScreenResize";
import normatecaStore from "../../stores/normatecaStore";
import {toast} from "react-toastify";
import Swal from 'sweetalert2';

export default function Encuesta(){
    const imgurl= process.env.REACT_APP_IMG_URL;
    const screen = ScreenResize();
    const {setEnviaEncu,envio,intra,nombreUsuario,visEnc,setVisEnc,intraCorreo,correoNorma} =
    normatecaStore((state) =>( { 
        setEnviaEncu: state.setEnviaEncu,
        envio: state.envio,
        intra: state.intra,
        nombreUsuario:state.nombreUsuario,
        visEnc:state.visEnc,
        setVisEnc: state.setVisEnc,
        intraCorreo: state.intraCorreo,
        correoNorma: state.correoNorma,
    })); 
    const [numSel, setNumSel]=useState(null);
    const [cs, setCS]=useState("");
    const [correo, setCorreo]=useState(intra? intraCorreo : "");
    const [radInfBus, setRadioInfBus]=useState("si");
    const [radFacEnc, setRadioFacEnc]=useState("si");
    const num=[0,1,2,3,4,5];
    const abrirEnc=()=>{
        setVisEnc();
        
    } 
    const selecNum =(num)=>{
        setNumSel(num);
    }
    const enviaEncuesta=()=>{
        let mensajeResp="";
        let mensajeTem1="";
        let mensajeTem2="";
        let mensajeTem3="";
        let mensajeTem4="";
        if (radInfBus===""){
            mensajeTem1= "Debe seleccionar una opción de la pregunta número 1\n";
        }
        if (radFacEnc===""){
            mensajeTem2= "Debe seleccionar una opción de la pregunta número 2\n";
        }
        if (numSel===null){
            mensajeTem3= "Debe seleccionar una opción de la pregunta número 3\n";
        }
        if (!intra && correo!==""){
            let validEmail =  /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
            if( !validEmail.test(correo) ){
                mensajeTem4="La dirección de correo no tiene un formato válido";
            }
        }
        if (mensajeTem1!=="" || mensajeTem2!=="" || mensajeTem3!=="" || mensajeTem4!==""){
            toast.warning(() => (
                <>
                    {mensajeTem1!=="" ? <div>{mensajeTem1}</div>:null}
                    {mensajeTem2!=="" ? <div>{mensajeTem2}</div>:null}
                    {mensajeTem3!=="" ? <div>{mensajeTem3}</div>:null}
                    {mensajeTem4!=="" ? <div>{mensajeTem4}</div>:null}
                </>
            ));
        }
        else{
            setEnviaEncu(radInfBus,radFacEnc,numSel,cs,correo,correoNorma).then(function(data){
                if (data){
                    mensajeResp="La información ha sido enviada";
                }
                else{
                    mensajeResp="La información NO se envío correctamente";
                }
                Swal.fire({//mensaje de confirmación
                title: mensajeResp,
                text: "",
                icon: 'info',
                showConfirmButton:true,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                //cancelButtonColor: '#0077C8',
                confirmButtonText: 'Aceptar',
                //cancelButtonText: 'Cerrar',
               // html: '<div>' + mensajeTem1 + '</div>' + '<div>' + mensajeTem2 + '</div>' + '<div>' + mensajeTem3 + '</div>'
                }).then((result) => {
                if (result.isConfirmed) {
                    if (data){
                        setNumSel(null);
                        setCS("");
                        setCorreo("");
                        setRadioInfBus("si");
                        setRadioFacEnc("si");
                    }
                }
                }) 
            });

        }
    }
    
    return(
        <div className={screen.width<=991 ? "divEncu2" : "divEncu"} >
             <div className={screen.width<=991? "display-block":"display-none"} >
                <a onClick={abrirEnc} className="aEncu" title={visEnc? "Cerrar": "Encuesta"}>
                    { visEnc?
                        <img src={imgurl + "normateca/buzoncierra.png"} className="imgEncuXT"/> 
                        :
                        <img src={imgurl + "normateca/buzonabre.png"} className="imgEncuXT"/> 
                    }
                </a>
            </div>
            <div className={visEnc? "divPreguntas visib-visible":"divPreguntas visib-hidden"} >
                <div className="divPregEnc">¿Qué opinas de la NORMATECA?</div>
                <div className="padding-1">
                    <div className={envio? "padBottom-05 display-bock":"display-none"}>
                        <p>Gracias{intra? " " + nombreUsuario:null}, tú opinión es importante para nosotros</p>
                    </div>
                    <div className={!envio? "display-bock":"display-none"}>
                        <div className="padBottom-05">
                            <p className={intra? "display-block":"display-none"}>Hola {nombreUsuario}</p>
                            <div>¿Encontraste la información que buscabas?</div>
                            <input type="radio" value="si" name="radEnc" onChange={e=>setRadioInfBus(e.target.value)} checked={radInfBus=== "si"}/> Si
                            <input type="radio" value="no" name="radEnc" className="margin-left1" onChange={e=>setRadioInfBus(e.target.value)} checked={radInfBus=== "no"}/> No
                        </div>
                        <div className="padBottom-05">
                            <div>¿Fue fácil encontrarla?</div>
                            <input type="radio" value="si" name="radFacEnc" onChange={e=>setRadioFacEnc(e.target.value)} checked={radFacEnc === "si"}/> Si
                            <input type="radio" value="no" name="radFacEnc" className="margin-left1" onChange={e=>setRadioFacEnc(e.target.value)} checked={radFacEnc=== "no"}/> No
                        </div>
                        <div className="padBottom-05">
                            <div>¿Cómo calificarías tu experiencia de navegación en el sitio el día de hoy?</div>
                            <table className="tablaEncu"><tbody><tr>
                                {num.map((n,index)=>(
                                    <td key={"n" + index.toString()} onClick={()=>selecNum(index)} className={index===numSel? "selNum":""}>{n}</td>
                                ))}
                            </tr>
                            </tbody>
                            </table>
                            <img src={ImgEncu} className="imgEncu" />
                        </div>
                        <div className="padBottom-05">
                            <div>Comentarios y sugerencias</div>
                            <textarea value={cs} name="CS" placeholder="Comentarios" className="ComSug" onChange={e=>setCS(e.target.value)} maxLength={500}/> 
                        </div>
                        <div className={intra? "display-none":"padBottom-05 display-block"}>
                            <div>Correo electrónico</div>
                            <input type="email" value={correo} name="co" placeholder="Correo" className="width-100" onChange={e=>setCorreo(e.target.value)}  maxLength={200}/> 
                        </div>
                        <div className="padBottom-05">
                            <div><button onClick={enviaEncuesta} type="button" className="btnEnviaOpi">Enviar</button></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={screen.width>=991? "display-block":"display-none"}>
                <a onClick={abrirEnc} className="aEncu"  title={visEnc? "Cerrar": "Encuesta"}>
                    { visEnc?
                        <img src={imgurl + "normateca/buzoncierra.png"} /> 
                        :
                        <img src={imgurl + "normateca/buzonabre.png"} /> 
                    }
                </a>
            </div>
 
        </div>
    )
}